const scopeId = (value) => (value == null || value === "" ? "" : String(value));

const authScope = (authorization) => authorization || "";

export const studyDashboardQueryKeys = {
  root: ["studyDashboard"],
  progress: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "progress",
    authScope(authorization),
  ],
  streak: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "streak",
    authScope(authorization),
  ],
  leaderboard: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "leaderboard",
    authScope(authorization),
  ],
  resumeVideo: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "resumeVideo",
    authScope(authorization),
  ],
  resumeTests: (authorization, courseId, batchId, classId, targetId) => [
    ...studyDashboardQueryKeys.root,
    "resumeTests",
    authScope(authorization),
    scopeId(courseId),
    scopeId(batchId),
    scopeId(classId),
    scopeId(targetId),
  ],
  exploreStore: (authorization, courseId, classId, targetId) => [
    ...studyDashboardQueryKeys.root,
    "exploreStore",
    "withStoreCatalogAndHandbooks",
    authScope(authorization),
    scopeId(courseId),
    scopeId(classId),
    scopeId(targetId),
  ],
  handbookList: (authorization, productId = "") => [
    ...studyDashboardQueryKeys.root,
    "handbookList",
    authScope(authorization),
    scopeId(productId),
  ],
  storeBanner: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "storeBanner",
    authScope(authorization),
  ],
  homeSliderBanners: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "homeSliderBanners",
    authScope(authorization),
  ],
  dailyGoal: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "dailyGoal",
    authScope(authorization),
  ],
  topWeakTopics: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "topWeakTopics",
    authScope(authorization),
  ],
  testWiseAnalysis: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "testWiseAnalysis",
    authScope(authorization),
  ],
  subjectPerformance: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "subjectPerformance",
    authScope(authorization),
  ],
  userProfile: (authorization, targetId) => [
    ...studyDashboardQueryKeys.root,
    "userProfile",
    authScope(authorization),
    scopeId(targetId),
  ],
  subjectList: (authorization, courseId, classId, targetId) => [
    ...studyDashboardQueryKeys.root,
    "subjectList",
    authScope(authorization),
    scopeId(courseId),
    scopeId(classId),
    scopeId(targetId),
  ],
  practiceList: (authorization, targetId) => [
    ...studyDashboardQueryKeys.root,
    "practiceList",
    authScope(authorization),
    scopeId(targetId),
  ],
  scheduleWeek: (authorization, courseId, batchId) => [
    ...studyDashboardQueryKeys.root,
    "scheduleWeek",
    authScope(authorization),
    scopeId(courseId),
    scopeId(batchId),
  ],
  scheduleContent: (authorization, courseId, batchId, dayName, rawDate) => [
    ...studyDashboardQueryKeys.root,
    "scheduleContent",
    authScope(authorization),
    scopeId(courseId),
    scopeId(batchId),
    scopeId(dayName),
    scopeId(rawDate),
  ],
};

/** Prefixes whose scores or resume state change after an exam or homework submit. */
export const studyDashboardAssessmentQueryKeys = [
  [...studyDashboardQueryKeys.root, "progress"],
  [...studyDashboardQueryKeys.root, "streak"],
  [...studyDashboardQueryKeys.root, "leaderboard"],
  [...studyDashboardQueryKeys.root, "resumeVideo"],
  [...studyDashboardQueryKeys.root, "resumeTests"],
  [...studyDashboardQueryKeys.root, "topWeakTopics"],
  [...studyDashboardQueryKeys.root, "testWiseAnalysis"],
  [...studyDashboardQueryKeys.root, "subjectPerformance"],
  [...studyDashboardQueryKeys.root, "scheduleContent"],
];

export const studyDashboardResumeQueryKey = [
  ...studyDashboardQueryKeys.root,
  "resumeVideo",
];
